import DiffMatchPatch from 'diff-match-patch';

import {
  DIFF_DELETE_BG_COLOR,
  DIFF_INSERT_BG_COLOR,
} from '@/constants/diffConstants';
import { Text } from '@/design-system';
import { DiffChangeType } from '@/types/diff';
import { cn } from '@/utils/tailwind';

import { MAX_TEXT_LENGTH } from '../Code/constants';
import { ExpandableText } from '../ExpandableText';

const JsonDiff = ({
  diffs,
  truncate,
}: {
  diffs: DiffChangeType[];
  truncate?: boolean;
}) => {
  const totalText = diffs.map(([_, text]) => text).join('');

  const renderDiffElements = (maxLength: number) => {
    let currentLength = 0;

    return diffs
      .map(([change, text], index) => {
        // If we've exceeded maxLength, skip
        if (currentLength >= maxLength) return null;

        // Truncate text if it would exceed maxLength
        const displayText =
          currentLength + text.length > maxLength
            ? text.slice(0, maxLength - currentLength)
            : text;

        currentLength += displayText.length;

        if (change === DiffMatchPatch.DIFF_EQUAL) {
          return (
            <Text key={index} as="span">
              {displayText}
            </Text>
          );
        }
        if (change === DiffMatchPatch.DIFF_DELETE) {
          return (
            <Text key={index} className={DIFF_DELETE_BG_COLOR} as="span">
              {displayText}
            </Text>
          );
        }
        if (change === DiffMatchPatch.DIFF_INSERT) {
          return (
            <Text key={index} className={DIFF_INSERT_BG_COLOR} as="span">
              {displayText}
            </Text>
          );
        }
        return null;
      })
      .filter(Boolean);
  };

  return (
    <pre
      className={cn(
        'flex-wrap overflow-y-auto whitespace-pre-wrap break-words font-mono'
      )}
    >
      {truncate ? (
        <ExpandableText
          text={totalText}
          initialMaxLength={MAX_TEXT_LENGTH}
          incrementLength={5000}
          renderContent={renderDiffElements}
        />
      ) : (
        renderDiffElements(totalText.length)
      )}
    </pre>
  );
};

export default JsonDiff;
